import { useEffect } from 'react';

interface SchemaOrgProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
  id?: string;
}

export default function SchemaOrg({ schema, id = 'schema-org' }: SchemaOrgProps) {
  useEffect(() => {
    const existing = document.querySelector(`script[data-schema-id="${id}"]`);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema-id', id);
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.querySelector(`script[data-schema-id="${id}"]`);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
}
